import React from 'react';

const ObligationSource = ({ source }) => {
  return source && source.trim ? (
    <div className="text-neutral-500 mb-2">Obligation source: {source}</div>
  ) : null;
};

export default ObligationSource;
